import { cn } from "@omni/utils/styles";

import { useSearchBoxContext } from "@/components/Search/SearchBar/components/SearchBox/context/searchBox.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const CloseButton = ({ className }: Props) => {
    const { isOpen, onCloseClick } = useSearchBoxContext();
    const { t } = useGranite();

    if (!isOpen) return null;

    return (
        <button
            type={"button"}
            className={cn(className)}
            onClick={onCloseClick}
            tabIndex={isOpen ? 0 : -1}
            aria-label={t("accessibility.searchBox.close")}
        >
            <i className={cn("las la-lg la-arrow-left")} />
        </button>
    );
};
